import React, { useEffect, useState } from "react";
import { useLanguage } from "../../../context/LanguageContext";
import QuizCard from "./_components/quiz-card";
import { BaseUrlApi, ErrorMessage } from "../../../lib/api";
import axios from "axios";
import { toast } from "sonner";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from "../../../components/ui/card";
import { Skeleton } from "src/components/ui/skeleton";
import { useNavigate } from "react-router-dom";
import { QuizData } from "../../../lib/languages";
import CardSkeleton from "./../../../components/common/CardSkeleton";

export default function UserQuizzes() {
  const { language } = useLanguage();
  const t = QuizData[language] || QuizData.en;
  const navigate = useNavigate();
  const [loadingQuizzes, setLoadingQuizzes] = useState(false);
  const [quizzes, setQuizzes] = useState([]);

  const getAllQuizzes = async () => {
    try {
      const { data } = await axios.get(`${BaseUrlApi}/student/quizzes`);
      setQuizzes(data.data);
    } catch (error) {
      toast("Error", { description: ErrorMessage(error) });
    } finally {
      setLoadingQuizzes(false);
    }
  };

  useEffect(() => {
    setLoadingQuizzes(true);
    getAllQuizzes();
  }, []);

  if (loadingQuizzes) {
    return <CardSkeleton />;
  }

  return (
    <div className="space-y-6" dir={language === "ar" ? "rtl" : "ltr"}>
      <h1 className="text-2xl font-bold mb-8">{t.availableQuizzesHeading}</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {quizzes.map((quiz, i) => (
          <QuizCard
            key={i}
            quiz={quiz}
            onStart={() => navigate("/quiz-exam", { state: { quiz } })}
          />
        ))}
      </div>
    </div>
  );
}
